import React from 'react';
import New_Dashboard from './New_Dashboard';

const NewDashboard = () => <New_Dashboard />;

export default NewDashboard;
